import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
// Helpers
import {
  getTimeFormatL,
  ProgressiveImageLoader,
  truncateString,
} from '../../common';
// Images
import EmptyBlend from '../images/blend_box.png';
// Components
import { Link } from 'react-router-dom';
import AddBlendToCartButton from '../containers/AddBlendToCartButton';
import BuyPrice from './BlendBuyPrice';
// Selector
import { deletingBlendTemplateLoadingSelector } from '../selectors';
// Style
import './BlendTemplateListItem.css';
import { deleteBlendTemplate } from '../actions';
// Types
import type {
  BlendTemplate,
  BlendTemplateItem as BlendTemplateItemType,
  Blend,
} from '../types';

type Props = {
  id: number,
  blendTemplate: BlendTemplate,
  blendTemplateItems: BlendTemplateItemType[],
  blend: Blend,
  clickable: boolean,
};

/**
 * Each template shown in the BlendsIndexPage (and other locations) is defined here.
 * Blends that are complete appear with the option of adding to cart or deleting.
 * Blends that are NOT complete appear as editable
 */
export class BlendTemplateListItem extends Component {
  props: Props;

  render() {
    const { blendTemplate, blendTemplateItems, blend, clickable } = this.props;

    const quantityKg = blendTemplate.defaultQuantity / 1000;

    const sortedItems = _.sortBy(blendTemplateItems, item => -item.quantity);

    const images = [].concat(...sortedItems.map(item => item.variant?.images));

    const isComplete = Boolean(blendTemplate.completedAt);

    const isAtMinQuantity =
      blend &&
      blend.quantity === blend.minQuantity;

    return (
      <div className="blend-hit">
        <div className="blend-hit-box-image">
          {_.isEmpty(blendTemplate.items) ? (
            <img src={EmptyBlend} alt="Nenhum item no blend" />
          ) : (
            <ProgressiveImageLoader
              selectedImage={images[0] || null}
              imageToShow="product"
            />
          )}
        </div>

        <div className="blend-hit-info">
          <h5 title={blendTemplate.name}>
            {truncateString(blendTemplate.name, 40)}
          </h5>

          <div className="blend-status-badges">
            {isComplete ? (
              <span className="blend-status-badge complete">
                <span className="dot" />
                Montado {getTimeFormatL(blendTemplate.completedAt)}
              </span>
            ) : (
              <span className="blend-status-badge open">
                <span className="dot" />
                Em aberto
              </span>
            )}
            {!blendTemplate.inStock && (
              <span
                className="blend-status-badge out-of-stock"
              >
                <span className="dot" />
                1 ou mais itens fora de estoque
              </span>
            )}
          </div>

          <div className="blend-hit-meta">
            <span className="blend-hit-meta-item">
              <i className="fa fa-balance-scale" />
              {quantityKg.toLocaleString('pt-br')} Kg
            </span>
          </div>

          {blendTemplate.observation && (
            <p className="blend-hit-observation" title={blendTemplate.observation}>
              {blendTemplate.observation}
            </p>
          )}
        </div>

        {isComplete ? (
          <div className="blend-actions">
            {/* TODO: show price/kg when not in cart; total + price/kg when in cart */}
            <BuyPrice
              blend={blend}
              listPrice={blendTemplate.price}
              price={blendTemplate.price}
              unit="g"
            />

            <div className="blend-hit-quantity">
              <AddBlendToCartButton
                blendTemplateId={blendTemplate.id}
                unitForQuantity="g"
                defaultQuantity={blendTemplate.defaultQuantity}
                incrementQuantity={blendTemplate.incrementQuantity}
                blend={blend}
                clickable={clickable}
                isOutOfStock={!blendTemplate.inStock}
              />

              {isAtMinQuantity && (
                <span>
                  {`Mín: ${(blend.minQuantity / 1000).toLocaleString('pt-br', {
                    currency: 'BRL',
                  })} Kg`}
                </span>
              )}
            </div>

            {/* TODO: add delete button here once it's safe to show alongside cart state */}
          </div>
        ) : (
          <div className="blend-edit-actions">
            <Link
              className="blend-action edit"
              to={`/blend/calculadora/${blendTemplate.id}/`}
            >
              <i className="fa fa-pencil" />
              <span>Editar</span>
            </Link>

            {this.props.deletingLoading ? (
              <div className="blend-action loading">
                <i className="fa fa-spinner fa-pulse" />
              </div>
            ) : (
              <button
                className="blend-action delete"
                onClick={() => this.props.deleteBlend(blendTemplate.id)}
              >
                <i className="fa fa-trash" />
                <span>Excluir</span>
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  deletingLoading: deletingBlendTemplateLoadingSelector(state),
});

const mapDispatchToProps = dispatch => ({
  deleteBlend: blendId => dispatch(deleteBlendTemplate(blendId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BlendTemplateListItem);
